// Register Vue
window.Vue = require("vue");

// General Components

import BasicScroll from "./components/basic-scroll";
import DirectionReveal from "./components/direction-info";
import Lazy from "./vendor/config.lazysizes";
import Observations from "./components/intersection-observer";
import InfiniteScroll from './components/InfiniteScroll';

// Vue Components
import contact_modal from "./components/ContactModal";
import contact_modal_trigger from "./components/ContactModalTrigger";
import content_slider from "./components/ContentSlider";
import counter from "./components/Counter";
import image_slider from './components/ImageSlider'
import job from './components/Job'
import jobs from './components/Jobs'
import smooth_scroll from "./components/SmoothScroll";
import site_menu from "./components/SiteMenu";
import tabs from "./components/Tabs";
import video_player_full from "./components/VideoFull";

// Initialize Vue
const app = new Vue({
  el: "#app",
  components: {
    contact_modal,
    contact_modal_trigger,
    content_slider,
    counter,
    image_slider,
    job,
    jobs,
    smooth_scroll,
    site_menu,
    tabs,
    video_player_full
  }
});

// Initialize General
Observations();
BasicScroll();
Lazy();
InfiniteScroll();
DirectionReveal();

// Test external link open in new tab
let all_links = document.querySelectorAll('a');

for (let i = 0; i < all_links.length; i++){
  let a = all_links[i];

  if(a.hostname != location.hostname) {
    a.rel = 'noopener';
    a.target = '_blank';
  }
}

// ---
// Notes
// Reflow issues stem from player.js (Vimeo) and TinySlider.js which make non-passive references to touch events and/or element dimensions
// ---
